import React from 'react'
import MetarDetailSection from './MetarDetailSection'
import MetarDetailSectionItem from './MetarDetailSectionItem'
import classnames from 'classnames'

const MetarDetailVisiblity = props => {

  const outlook = (visibility => {
    if(visibility && visibility.charAt(0) === "M") {
      visibility = visibility.substring(1)
    }
    visibility = eval(visibility)
    if(visibility <= 5) {
      if(visibility >= 3) {
        return "MVFR"
      }
      if(visibility >= 1) {
        return "IFR"
      }
      return "LIFR"
    }
    return "VFR"
  })(props.visibility)

  return (
    <MetarDetailSection
      title={"VISIBILITY"}
    >
      <MetarDetailSectionItem
        className={classnames({
          metarOutlookMVFR: outlook === 'MVFR',
          metarOutlookIFR: outlook === 'IFR',
          metarOutlookLIFR: outlook === 'LIFR'
        })}
        value={props.visibility}
        footer={"STATUTE MILES"}
      />
    </MetarDetailSection>
  )
}

export default MetarDetailVisiblity



// WEBPACK FOOTER //
// ./src/components/MetarDetailVisibility.js